import { Link, useIntl } from 'gatsby-plugin-intl';
import React, { useEffect, useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { isSelectedMenu } from '../../../utils/helpers/SideNavBarHelper';
import { Msg } from '../../../utils/helpers/MsgHelper';
import homeIcon from '../../../assets/images/home.svg';
import './SideNavBar.scss';
import { SideNavMenuConstants } from '../../../utils/constants/SideNavBarConstant';

interface SideNavBarProps {
  toggleResponsiveSideNavProps: Function;
}

/**
 * @component SideNavBar
 * @description Displays required menus and highlights selected menu.
 * Responsible for visiting a particular page once menu is clicked.
 */
const SideNavBar: React.FC<SideNavBarProps> = ({ toggleResponsiveSideNavProps }: SideNavBarProps) => {
  const [locationQueryString, setLocationQueryString] = useState<string>('');
  const [currentLocationPath, setCurrentLocationPath] = useState<string>('');

  const intl = useIntl();

  useEffect(() => {
    const pathName = window.location.pathname;
    const queryString = window.location.search;
    setCurrentLocationPath(pathName);
    setLocationQueryString(queryString);
  }, []);

  /**
   * @function menuClassName
   * @description Returns className for each 'menu' depending on whether user selected the menu or not.
   * Maps URL Path to actual menu using 'menu' index.
   * Menu indexes in this context means index positions of enum 'MENUS' present in SideNavBarConstant.ts.
   * @param menuIndex
   */
  const menuClassName = (menuIndex: number): string => {
    const menuSelected: boolean = isSelectedMenu(currentLocationPath, menuIndex, locationQueryString);
    return menuSelected ? 'menu-active' : '';
  };

  const toggleResponsiveSideNav = (): void => {
    if (window.innerWidth <= 768) {
      toggleResponsiveSideNavProps();
    }
  };

  const refreshHome = (): void => {
    window.location.assign('/');
  };

  return (
    <>
      <ListGroup className='side-menus'>
        <ListGroup.Item
          className={menuClassName(SideNavMenuConstants.DASHBOARD)}
          title='Dashboard'
          onClick={toggleResponsiveSideNav}
        >
          <Link to='/' onClick={refreshHome}>
            <span className='menu-icon'>
              <img alt='Home' src={homeIcon} width='24' height='24' className='mr-3' />
            </span>
            <span className='menu-title'>{Msg(intl, 'navigationMenu.mainMenu.dashboard')}</span>
          </Link>
        </ListGroup.Item>
      </ListGroup>
    </>
  );
};

export default SideNavBar;
